import { render, staticRenderFns } from "./edit-letter.vue?vue&type=template&id=55b61948&scoped=true&"
import script from "./edit-letter.vue?vue&type=script&lang=js&"
export * from "./edit-letter.vue?vue&type=script&lang=js&"
import style0 from "./edit-letter.vue?vue&type=style&index=0&id=55b61948&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b61948",
  null
  
)

export default component.exports